module.exports = __webpack_public_path__ + "img/ico-preview.6d320a5e.svg";